export const SEND_STORE_MESSAGE = "actions/SEND_STORE_MESSAGE";
export const SEND_STORE_MESSAGE_SUCCESS = "actions/SEND_STORE_MESSAGE_SUCCESS";
export const SEND_STORE_MESSAGE_FAIL = "actions/SEND_STORE_MESSAGE_FAIL";
